import {
  createDummyScreenshot,
  MOCK_ALERTS_WITH_SCREENSHOTS,
} from "./alert-screenshot-dummy-data";

export const mockUsers = [
  {
    id: 1,
    name: "Alice Johnson",
    email: "alice@company.com",
    designation: "QA Engineer",
    lastLogin: "2024-01-15 09:30",
    role: "Admin",
    invitedBy: "System",
    status: "Active",
  },
  {
    id: 2,
    name: "Bob Smith",
    email: "bob@company.com",
    designation: "Lab Technician",
    lastLogin: "2024-01-14 14:20",
    role: "Operator",
    invitedBy: "Alice Johnson",
    status: "Active",
  },
  {
    id: 3,
    name: "Carol Davis",
    email: "carol@company.com",
    designation: "Manager",
    lastLogin: "—",
    role: "Viewer",
    invitedBy: "Alice Johnson",
    status: "Invited",
  },
  {
    id: 4,
    name: "Dan Wilson",
    email: "dan@company.com",
    designation: "Analyst",
    lastLogin: "2024-01-10 11:00",
    role: "Operator",
    invitedBy: "Bob Smith",
    status: "Deactivated",
  },
  {
    id: 5,
    name: "Eva Brown",
    email: "eva@company.com",
    designation: "Supervisor",
    lastLogin: "2024-01-15 08:15",
    role: "Admin",
    invitedBy: "System",
    status: "Active",
  },
];

export const mockPermissions = [
  {
    id: "perm-1",
    name: "List users",
    resource: "users",
    action: "read",
  },
  {
    id: "perm-2",
    name: "Create user",
    resource: "users",
    action: "create",
  },
  {
    id: "perm-3",
    name: "List roles",
    resource: "roles",
    action: "read",
  },
  {
    id: "perm-4",
    name: "List frames",
    resource: "alerts",
    action: "read",
  },
  {
    id: "perm-5",
    name: "List videos",
    resource: "videos",
    action: "read",
  },
  {
    id: "perm-6",
    name: "View dashboard stats",
    resource: "dashboard",
    action: "read",
  },
];

export const mockRoles = [
  {
    id: 1,
    name: "Viewer",
    code: "VIEWER",
    status: "Active",
    permissions: 0,
    users: 10,
  },
  {
    id: 2,
    name: "Reviewer",
    code: "REVIEWER",
    status: "Active",
    permissions: 0,
    users: 5,
  },
  {
    id: 3,
    name: "Auditor",
    code: "AUDITOR",
    status: "Active",
    permissions: 0,
    users: 2,
  },
  {
    id: 4,
    name: "Admin",
    code: "ADMIN",
    status: "Active",
    permissions: 0,
    users: 3,
  },
];

export const mockScreenshots = [
  {
    id: 1,
    video: "cleanroom_batch_042.mp4",
    videoId: 1,
    timestamp: "00:04:32",
    capturedAt: "2024-01-15 09:34",
    image:
      "/sample-1/Shot 9 Smoke source inside UAF (SM-586) (filter 1 of 2).mp4_frame_00000.jpg",
    user: {
      name: "Alice Johnson",
      email: "alice@company.com",
    },
    project: "Smoke Study Analysis",
    status: "Pending",
  },
  {
    id: 2,
    video: "cleanroom_batch_042.mp4",
    videoId: 1,
    timestamp: "00:12:18",
    capturedAt: "2024-01-15 09:42",
    image:
      "/sample-1/Shot 9 Smoke source inside UAF (SM-586) (filter 1 of 2).mp4_frame_00001.jpg",
    user: {
      name: "Eva Brown",
      email: "eva@company.com",
    },
    project: "Smoke Study Analysis",
    ipAddress: "192.168.1.15",
    status: "Approved",
  },
  {
    id: 3,
    video: "cleanroom_batch_040.mp4",
    videoId: 3,
    timestamp: "00:02:10",
    capturedAt: "2024-01-13 11:02",
    image:
      "/sample-3/Shot 5 Outfeed turn table and adjacent conveyor belt.mp4_frame_00001.jpg",
    user: {
      name: "Alice Johnson",
      email: "alice@company.com",
    },
    project: "Batch Monitoring",
    ipAddress: "192.168.1.42",
    status: "Pending",
  },
  {
    id: 4,
    video: "cleanroom_batch_040.mp4",
    videoId: 3,
    timestamp: "00:08:55",
    capturedAt: "2024-01-13 11:09",
    image:
      "/sample-3/Shot 5 Outfeed turn table and adjacent conveyor belt.mp4_frame_00002.jpg",
    user: {
      name: "Bob Smith",
      email: "bob@company.com",
    },
    project: "Batch Monitoring",
    ipAddress: "192.168.1.20",
    status: "Rejected",
  },
  {
    id: 5,
    video: "cleanroom_batch_040.mp4",
    videoId: 3,
    timestamp: "00:14:22",
    capturedAt: "2024-01-13 11:14",
    image:
      "/sample-3/Shot 5 Outfeed turn table and adjacent conveyor belt.mp4_frame_00003.jpg",
    user: {
      name: "Bob Smith",
      email: "bob@company.com",
    },
    project: "Batch Monitoring",
    ipAddress: "192.168.1.20",
    status: "Pending",
  },
  {
    id: 6,
    video: "cleanroom_batch_039.mp4",
    videoId: 4,
    timestamp: "00:06:11",
    capturedAt: "2024-01-12 16:51",
    image: "/sample-2/01. FS_Left Side filter.mp4_frame_00000.jpg",
    user: {
      name: "Dan Wilson",
      email: "dan@company.com",
    },
    project: "Internal Audit",
    ipAddress: "10.0.0.5",
    status: "Approved",
  },
];

export const mockAuditTrail = [
  {
    id: 1,
    video: "cleanroom_batch_042.mp4",
    action: "Upload",
    user: "Alice Johnson",
    time: "2024-01-15 09:30",
    detail: "Video uploaded for evaluation",
  },
  {
    id: 2,
    video: "cleanroom_batch_042.mp4",
    action: "Evaluation Started",
    user: "System",
    time: "2024-01-15 09:31",
    detail: "AI evaluation initiated",
  },
  {
    id: 3,
    video: "cleanroom_batch_042.mp4",
    action: "Alert Generated",
    user: "System",
    time: "2024-01-15 09:34",
    detail: "3 frames detected",
  },
  {
    id: 4,
    video: "cleanroom_batch_041.mp4",
    action: "Upload",
    user: "Bob Smith",
    time: "2024-01-14 14:20",
    detail: "Video uploaded for evaluation",
  },
  {
    id: 5,
    video: "cleanroom_batch_041.mp4",
    action: "Evaluation Complete",
    user: "System",
    time: "2024-01-14 14:35",
    detail: "No issues found",
  },
  {
    id: 6,
    video: "cleanroom_batch_040.mp4",
    action: "Upload",
    user: "Alice Johnson",
    time: "2024-01-13 11:00",
    detail: "Video uploaded for evaluation",
  },
  {
    id: 7,
    video: "cleanroom_batch_040.mp4",
    action: "Alert Generated",
    user: "System",
    time: "2024-01-13 11:05",
    detail: "7 frames detected - critical",
  },
];
export const mockTrailDetail = [
  {
    videoId: 1,
    action: "Evaluation Complete",
    user: "System",
    time: "2024-01-15 09:40:00",
    detail: "3 frames generated, 12 screenshots captured",
    ip: "System",
  },
  {
    videoId: 1,
    action: "Alert Generated",
    user: "System",
    time: "2024-01-15 09:34:28",
    detail: "PPE non-compliance in Zone B",
    ip: "System",
  },
  {
    videoId: 1,
    action: "Alert Generated",
    user: "System",
    time: "2024-01-15 09:34:15",
    detail: "Movement violation in Zone A",
    ip: "System",
  },
  {
    videoId: 1,
    action: "Alert Generated",
    user: "System",
    time: "2024-01-15 09:34:01",
    detail: "Contamination detected in Zone B",
    ip: "System",
  },
  {
    videoId: 1,
    action: "Frame Captured",
    user: "System",
    time: "2024-01-15 09:32:45",
    detail: "Screenshot captured at 00:04:32",
    ip: "System",
  },
  {
    videoId: 1,
    action: "Evaluation Started",
    user: "System",
    time: "2024-01-15 09:31:12",
    detail: "AI evaluation initiated",
    ip: "System",
  },
  {
    videoId: 1,
    action: "Upload",
    user: "Alice Johnson",
    time: "2024-01-15 09:30:00",
    detail: "Video uploaded for evaluation",
    ip: "192.168.1.42",
  },
  {
    videoId: 3,
    action: "Evaluation Complete",
    user: "System",
    time: "2024-01-13 11:20:00",
    detail: "7 frames generated, 24 screenshots captured",
    ip: "System",
  },
  {
    videoId: 3,
    action: "Upload",
    user: "Alice Johnson",
    time: "2024-01-13 11:00:00",
    detail: "Video uploaded for evaluation",
    ip: "192.168.1.42",
  },
];

export const mockVideos = [
  {
    id: 1,
    name: "cleanroom_batch_042.mp4",
    alerts: 10,
    audit: "/sample-1/audit.csv",
    deviation: "/sample-1/deviation.csv",
  },
  {
    id: 2,
    name: "cleanroom_batch_041.mp4",
    alerts: 0,
    audit: "/sample-2/audit.csv",
    deviation: "/sample-2/deviation.csv",
  },
  {
    id: 3,
    name: "cleanroom_batch_040.mp4",
    alerts: 2,
    audit: "/sample-3/audit.csv",
    deviation: "/sample-3/deviation.csv",
  },
];

export {
  MOCK_ALERT_SCREENSHOT_VIEWER_FIXTURES,
  MOCK_ALERTS_WITH_SCREENSHOTS,
  createDummyScreenshot,
  DUMMY_SCREENSHOT_IMAGES,
} from "./alert-screenshot-dummy-data";

export const mockAlerts = [
  ...MOCK_ALERTS_WITH_SCREENSHOTS,
  {
    id: 11,
    videoId: 3,
    type: "Non-Unidirectional",
    zone: "Zone C",
    timestamp: "00:02:10",
    severity: "Critical",
    confidencePercentage: 84,
    screenshot: createDummyScreenshot(
      11,
      10,
      "Outfeed conveyor smoke drift (sample video 3)",
    ),
    status: "Pending",
  },
  {
    id: 12,
    videoId: 3,
    type: "Non-Laminar",
    zone: "Zone A",
    timestamp: "00:08:55",
    severity: "Critical",
    confidencePercentage: 91,
    screenshot: createDummyScreenshot(
      12,
      11,
      "Turn-table turbulence at outfeed (sample video 3)",
    ),
    status: "Pending",
  },
];
